import { render, staticRenderFns } from "./TabsGallery.vue?vue&type=template&id=bde79268&scoped=true&"
import script from "./TabsGallery.vue?vue&type=script&lang=js&"
export * from "./TabsGallery.vue?vue&type=script&lang=js&"
import style0 from "./TabsGallery.vue?vue&type=style&index=0&id=bde79268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde79268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde79268')) {
      api.createRecord('bde79268', component.options)
    } else {
      api.reload('bde79268', component.options)
    }
    module.hot.accept("./TabsGallery.vue?vue&type=template&id=bde79268&scoped=true&", function () {
      api.rerender('bde79268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/TabsGallery.vue"
export default component.exports